var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contact-us"},[_c('a',{attrs:{"href":`tel:${_vm.supplierPhone}`}},[_vm._v("Having trouble? Call "+_vm._s(_vm.supplierName)+" on "),_c('b',[_vm._v(_vm._s(_vm.supplierPhone))])]),_c('small',{staticClass:"_margin-top-10"},[_vm._v("Monday to Friday 9am to 5pm")]),_c('small',[_vm._v("Closed on Bank Holidays")])])
}
var staticRenderFns = []

export { render, staticRenderFns }